import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import Heading from "@scentregroup/ui/components/heading";
import ParkingRates from "@scentregroup/ui/components/parking-rates";
import sortBy from 'lodash/sortBy';
import max from 'lodash/max';
import omit from 'lodash/omit';
import { parkingZones } from '../parking';
import Markdown from '../markdown';
import Trackable from '../trackable';
import { trackingActions, trackingTypes } from '../../constants';
import { jsx as _jsx } from "react/jsx-runtime";
const MINS_IN_HOUR = 60;
const EFFECTIVELY_INFINITY = 100000;
function bodyFromParkingRules(parkingModule) {
  var _parkingModule$ratesC;
  const rateCards = (_parkingModule$ratesC = parkingModule.ratesCardsCollection) === null || _parkingModule$ratesC === void 0 ? void 0 : _parkingModule$ratesC.items.map(rateCard => {
    var _rateCard$ratesCollec;
    const unsortedRates = rateCard === null || rateCard === void 0 || (_rateCard$ratesCollec = rateCard.ratesCollection) === null || _rateCard$ratesCollec === void 0 ? void 0 : _rateCard$ratesCollec.items.map(rate => _objectSpread({
      to: (rate === null || rate === void 0 ? void 0 : rate.toInMinutes) && rate.toInMinutes / MINS_IN_HOUR
    }, rate));
    const rates = sortBy(unsortedRates, rate => rate.to || EFFECTIVELY_INFINITY);
    const maximumRate = max(rates.map(rate => rate.rate));
    return _objectSpread(_objectSpread({}, omit(rateCard, 'ratesCollection')), {}, {
      rates,
      maximumRate
    });
  });
  const parkingRateProps = _objectSpread(_objectSpread({}, omit(parkingModule, 'ratesCardsCollection')), {}, {
    rateCards
  });
  const cinemaValidation = parkingRateProps.cinemaValidation ? /*#__PURE__*/_jsx(Markdown, {
    content: parkingRateProps.cinemaValidation,
    "data-id": "parking-modules_accordion-entries-from-modules_bodyFromParkingRules_Markdown"
  }) : null;
  return /*#__PURE__*/_jsx(ParkingRates, _objectSpread(_objectSpread({}, parkingRateProps), {}, {
    cinemaValidation: cinemaValidation,
    heading: "",
    "data-id": "parking-modules_accordion-entries-from-modules_bodyFromParkingRules_ParkingRates"
  }));
}
function rowsFromCarParkGroup(parkingModule, centre) {
  var _parkingModule$carPar;
  const carParks = (_parkingModule$carPar = parkingModule.carParksCollection) === null || _parkingModule$carPar === void 0 ? void 0 : _parkingModule$carPar.items;
  const parkZones = parkingZones({
    carParks,
    centre,
    noBorder: true
  });
  return parkZones.map(content => ({
    content
  }));
}
export default function accordionEntriesFromModules(modules, centre) {
  return modules.flatMap(parkingModule => {
    if (!parkingModule) {
      return [];
    }
    const typename = parkingModule.__typename;
    const title = parkingModule.title;
    const heading = /*#__PURE__*/_jsx(Heading, {
      type: "medium",
      "data-id": "parking-modules_accordion-entries-from-modules_bodyFromParkingRules_Heading",
      children: title || typename
    });
    const expandTitle = {
      closed: heading,
      opened: heading
    };
    if ('carParksCollection' in parkingModule) {
      const rows = rowsFromCarParkGroup(parkingModule, centre);
      return {
        expandTitle,
        rows
      };
    }
    let body = '';
    if ('ratesCardsCollection' in parkingModule) {
      body = bodyFromParkingRules(parkingModule);
    } else if ('bodyCopy' in parkingModule) {
      body = /*#__PURE__*/_jsx(Markdown, {
        content: parkingModule.bodyCopy,
        "data-id": "parking-modules_accordion-entries-from-modules_bodyFromParkingRules_Markdown"
      });
    }
    body = /*#__PURE__*/_jsx(Trackable, _objectSpread(_objectSpread({}, parkingModule.analyticsMetadata), {}, {
      trackingAction: trackingActions.viewPromotion,
      type: trackingTypes.promotion,
      "data-id": "parking-modules_accordion-entries-from-modules_bodyFromParkingRules_Trackable",
      children: body
    }));
    const rows = [{
      content: body
    }];
    return {
      expandTitle,
      rows
    };
  });
}